import React, { useEffect, useState, useCallback, useMemo, useRef } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import api from "../../utils/api";
import { toast } from "react-toastify";
import Modal from 'react-modal'
import ModalContent from "../../common/Modal/ModalContent";
import close_modal from '../../assets/ic_close_wh.svg'

const CustomHeader = ({ displayName }) => {
    return (
        <div style={{ display: "flex", width: '100%', alignItems: "center", whiteSpace: 'normal' }}>
            {displayName}
        </div>
    );
};

const ResourceMasterTable = (props) => {

    const gridRef = useRef()
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const [deleteId, setDeleteId] = useState()

    const deleteResource = () => {
        console.log(deleteId)
        api.deleteResourceMasterData({ id: deleteId })
            .then(({ data }) => {
                console.log("Delete", data)
                if (data.Message === "Deleted Successfully.") {
                    toast("Resource Deleted Successfully", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    })
                }
                props.getResourceMasterTableData()
                openConfirmationModalisFalse()
            })

    }


    const confirmDelete = (e) => {
        setDeleteId(e.id)
        openConfirmationModalisTrue()

    }

    const [confirmationModal, setConfirmationModal] = useState(false)
    const openConfirmationModalisTrue = () => {
        setConfirmationModal(true)
    }

    const openConfirmationModalisFalse = () => {
        setConfirmationModal(false)
    }

    const gridOptions = {
        // ... other grid options ...
        rowHeight: 40, // Adjust the row height here
    };

    const rowData = props.resourceMasterData

    // old wirth all extra data
    // const columnDefs = [
    //     {
    //         field: 'id', headerName: 'ID', headerComponentFramework: CustomHeader, width: 70, cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         field: 'rId', headerName: 'Resource ID', headerComponentFramework: CustomHeader, cellStyle: {
    //             'white-space': 'normal', 'line-height': '2.5', 'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //         autoHeight: true, width: 200
    //     },
    //     { field: 'rResourceType', headerName: 'Resource Type', headerComponentFramework: CustomHeader, width: 200 },
    //     {
    //         field: 'rResourceSubType', headerName: 'Resource Subtype', headerComponentFramework: CustomHeader, width: 120, cellStyle: {
    //             'white-space': 'normal', 'line-height': '2.5', 'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //         autoHeight: true
    //     },
    //     {
    //         field: 'rResourceCategory', headerName: 'Resource Category', headerComponentFramework: CustomHeader, cellStyle: {
    //             'white-space': 'normal', 'line-height': '2.5', 'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //         autoHeight: true, width: 300
    //     },
    //     {
    //         field: 'rResourceDisplayName', headerName: 'Resource Display Name', headerComponentFramework: CustomHeader, cellStyle: {
    //             'white-space': 'normal', 'line-height': '2.5', 'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //         autoHeight: true, width: 300
    //     },
    //     {
    //         field: 'blsFinancialDataService', headerName: 'Is Financial Data service', headerComponentFramework: CustomHeader, width: 115, cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         field: 'blsServiceProvider', headerName: 'Is Service Provider', headerComponentFramework: CustomHeader, width: 100, cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         field: 'bUnusedService', headerName: 'Unused Service', headerComponentFramework: CustomHeader, width: 100, cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         field: 'bServiceProviderOnly', headerName: 'Service Provider Only', headerComponentFramework: CustomHeader, width: 100, cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         field: 'bDisableService', headerName: 'Disable Service', headerComponentFramework: CustomHeader, width: 100, cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         field: 'bEngagementResource', headerName: 'Engagement Service', headerComponentFramework: CustomHeader, width: 130, cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         field: 'nExpectedTAT',
    //         headerName: 'Expected TAT',
    //         headerComponentFramework: CustomHeader,
    //         width: 100,
    //         valueFormatter: (params) => (params.value === null ? 0 : params.value),
    //         cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //     },
    //     {
    //         headerName: 'Action',
    //         cellRendererFramework: (params) => {
    //             return (
    //                 <>
    //                     {
    //                         params.data.is_deleted ?
    //                             <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", pointerEvents: 'none', opacity: 0.4 }}>
    //                                 <button
    //                                     type="button"
    //                                     onClick={() => props.editResource(params.data)}
    //                                     className={`my-services-model-cancel-btn`}>Edit</button>
    //                                 <button
    //                                     style={{
    //                                         width: "113px",
    //                                         margin: '5px 5px'
    //                                     }}
    //                                     // onClick={() => deleteResource(params.data)}
    //                                     onClick={() => confirmDelete(params.data)}
    //                                     className={`my-services-model-submit-btn`}>Deactivate</button>
    //                             </div>
    //                             :
    //                             <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
    //                                 <button
    //                                     type="button"
    //                                     onClick={() => props.editResource(params.data)}
    //                                     className={`my-services-model-cancel-btn`}>Edit</button>
    //                                 <button
    //                                     style={{
    //                                         width: "113px",
    //                                         margin: '5px 5px'
    //                                     }}
    //                                     // onClick={() => deleteResource(params.data)}
    //                                     onClick={() => confirmDelete(params.data)}
    //                                     className={`my-services-model-submit-btn`}>Deactivate</button>
    //                             </div>
    //                     }
    //                 </>

    //             );
    //         },
    //         headerComponentFramework: CustomHeader, width: 230,
    //         cellStyle: {
    //             'height': '100%',
    //             'display': 'flex ',
    //             'align-items': 'center ',
    //         },
    //         // pinned: 'right',
    //     },
    // ];

    // new
    const columnDefs = [
        // {
        //     field: 'id', headerName: 'ID', headerComponentFramework: CustomHeader, width: 70, cellStyle: {
        //         'height': '100%',
        //         'display': 'flex ',
        //         'align-items': 'center ',
        //     },
        // },
        {
            headerName: 'ID',
            headerComponentFramework: CustomHeader,
            width: 70,
            valueGetter: (params) => params.node.rowIndex + 1, // rowIndex starts from 0
            cellStyle: {
                height: '100%',
                display: 'flex',
                alignItems: 'center',
            },
        },
        {
            field: 'sResourceID', headerName: 'Resource ID', headerComponentFramework: CustomHeader, cellStyle: {
                'white-space': 'normal', 'line-height': '2.5', 'height': '100%',
                'display': 'flex ',
                'align-items': 'center ',
            },
            autoHeight: true, width: 250
        },
        { field: 'sResourceType', headerName: 'Resource Type', headerComponentFramework: CustomHeader, width: 250 },
        {
            field: 'sResourceSubType', headerName: 'Resource Subtype', headerComponentFramework: CustomHeader, width: 120, cellStyle: {
                'white-space': 'normal', 'line-height': '2.5', 'height': '100%',
                'display': 'flex ',
                'align-items': 'center ',
            },
            autoHeight: true,
            width: 250
        },
        {
            field: 'sResourceName', headerName: 'Resource Display Name', headerComponentFramework: CustomHeader, cellStyle: {
                'white-space': 'normal', 'line-height': '2.5', 'height': '100%',
                'display': 'flex ',
                'align-items': 'center ',
            },
            autoHeight: true,
            // width: 300
            // cellStyle: {
            //     'height': '100%',
            //     'display': 'flex ',
            //     'align-items': 'center ',
            // },
            flex: 1
        },
        // {
        //     headerName: 'Action',
        //     cellRendererFramework: (params) => {
        //         return (
        //             <>
        //                 {
        //                     params.data.is_deleted ?
        //                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center", pointerEvents: 'none', opacity: 0.4 }}>
        //                             <button
        //                                 type="button"
        //                                 onClick={() => props.editResource(params.data)}
        //                                 className={`my-services-model-cancel-btn`}>Edit</button>
        //                             <button
        //                                 style={{
        //                                     width: "113px",
        //                                     margin: '5px 5px'
        //                                 }}
        //                                 // onClick={() => deleteResource(params.data)}
        //                                 onClick={() => confirmDelete(params.data)}
        //                                 className={`my-services-model-submit-btn`}>Deactivate</button>
        //                         </div>
        //                         :
        //                         <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
        //                             <button
        //                                 type="button"
        //                                 onClick={() => props.editResource(params.data)}
        //                                 className={`my-services-model-cancel-btn`}>Edit</button>
        //                             <button
        //                                 style={{
        //                                     width: "113px",
        //                                     margin: '5px 5px'
        //                                 }}
        //                                 // onClick={() => deleteResource(params.data)}
        //                                 onClick={() => confirmDelete(params.data)}
        //                                 className={`my-services-model-submit-btn`}>Deactivate</button>
        //                         </div>
        //                 }
        //             </>

        //         );
        //     },
        //     headerComponentFramework: CustomHeader, width: 230,
        //     cellStyle: {
        //         'height': '100%',
        //         'display': 'flex ',
        //         'justify-content': 'center',
        //         'align-items': 'center ',
        //     },
        //     // pinned: 'right',
        //     // flex: 1
        // },
    ];
    console.log(props.resourceMasterData, ">>>>>resourceMasterData");

    return (
        <div>
            {/* Confirmation Modal */}

            <Modal isOpen={confirmationModal} style={{ zIndex: 1 }}>
                <ModalContent className="confirmation-modal-small">
                    <div className="modal-header" style={{
                        backgroundColor: '#76287C',
                        color: '#fff'
                    }}>
                        <span className="modal-title">Confirm</span>
                        <img
                            alt="close"
                            id="Close"
                            src={close_modal}
                            className="close modal-close"
                            onClick={openConfirmationModalisFalse}
                        />
                    </div>

                    <div className="modal-body">
                        Are you sure you want to perform this action?
                        <div className="row">
                            <div className="col-12 d-flex align-items-center" style={{
                                justifyContent: 'flex-end'
                            }}>
                                <button
                                    type="button"
                                    className="my-services-model-submit-btn conv-mr25"
                                    onClick={deleteResource}>
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    className="my-services-model-cancel-btn conv-mr25"
                                    onClick={() => {
                                        openConfirmationModalisFalse()
                                    }}>
                                    No
                                </button>
                            </div>

                        </div>
                    </div>
                </ModalContent>
            </Modal>
            <div style={{
                height: "75vh",
            }}>
                <div style={{
                    textAlign: 'right'
                }} className="mb-2">
                    <button className="my-services-model-submit-btn"
                        onClick={() => props.onAddClick()}
                    >Add Resource</button>
                </div>
                <div style={{ height: "100%", boxSizing: "border-box" }}>
                    <div style={gridStyle} className="ag-theme-material" >
                        <AgGridReact ref={gridRef}
                            rowData={rowData}
                            gridOptions={gridOptions}
                            columnDefs={columnDefs}
                        // pagination={true}
                        // paginationPageSize={15}
                        >
                        </AgGridReact>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResourceMasterTable
